// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"bfb495ba","592":"1d7aec8b","898":"26f7450f"}[chunkId] + ".chunk.js";
};